import memoize from 'transmute/memoize';
import { buildSenderLocator } from './buildSenderLocator';

/** @deprecated Use `getSender`. */
export const findSender = memoize((senderId, senderType, senders) => {
  if (!senderType) {
    return null;
  }
  return senders.get(buildSenderLocator(senderType, senderId));
});